import { render, staticRenderFns } from "./MoveTabNavigation-new.vue?vue&type=template&id=7d2309fb&scoped=true"
import script from "./MoveTabNavigation-new.vue?vue&type=script&lang=js"
export * from "./MoveTabNavigation-new.vue?vue&type=script&lang=js"
import style0 from "./MoveTabNavigation-new.vue?vue&type=style&index=0&id=7d2309fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2309fb",
  null
  
)

export default component.exports